import r from "../../shared-lib/braze-shared-lib.js";
import e from "../managers/braze-instance.js";
import ir from "./feature-flags-provider-factory.js";
export function getAllFeatureFlags() {
  if (!e.rr()) return;
  const t = [],
    a = e.ir();
  if (a && !a.ci()) return r.D.info("Feature flags are not enabled."), t;
  const o = ir.er().pi();
  for (const r in o) t.push(o[r]);
  return t;
}
